export default __webpack_public_path__ + "static/media/bebin-logo.bc5776e0.svg";